/**
 * Store accessor that is safe to import during module init.
 *
 * Prod crash this fixes:
 *   ReferenceError: Cannot access 'b' before initialization (minified as KA)
 *
 * Cause (circular import / TDZ):
 *   store/index.js exports `const store = createStore(...)`.
 *   createStore() loads rootReducer → persistedData.js.
 *   persistedData used to `import { store } from "@root/store"` at the top of the file.
 *   That import runs while store/index.js is still evaluating, so `store` exists as a
 *   binding but has not been assigned yet (temporal dead zone). Accessing it throws.
 *   Minify turns that into "Cannot access 'b' before initialization".
 *
 *   The cycle was:
 *     store/index → rootReducer → persistedData → @root/store (incomplete)
 *     persistedData → getAxiosConfig → @root/store + persistedData
 *
 * This module has no import of store/index, so it can load first. index.js calls
 * setStore(store) immediately after createStore. Callers use getStore() at *runtime*
 * (inside functions), not at import time.
 *
 * getStore() is null only until setStore runs (during createStore, before this
 * module is registered). After boot it is the live store. Callers use optional
 * chaining so a too-early call skips the dispatch instead of crashing.
 */
let storeInstance = null;

export function setStore(store) {
  storeInstance = store;
}

export function getStore() {
  return storeInstance;
}
